
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  errorMessage: null
};

function showErrorToast(action) {
  return action.type.endsWith('/rejected') &&
         // Show toasts for documents only if ...
         (!action.type.startsWith('document/') ||
         // response code is 423 (email not verified)
         action.error.message === "423" ||
         // or there is a permission problem
         action.error.message === "403" ||
         // or the 'thing' is not found
         action.error.message === "404" ||
         // or there's something wrong when moving images
         action.type.startsWith('document/moveImageToSection') || action.type.startsWith('document/moveImage') ||
         // error when asking from AI
         action.type.startsWith('document/askAISuggestion') ||
         action.type.startsWith('document/askAIImageTitle') ||
         action.type.startsWith('document/askAIAboutDocument')
        ) &&
        !action.meta?.arg?.suppressErrorMessage;
  ;
}

// Helper function to safely filter out documentSaveCtx from the action
function sanitizeErrorAction(action) {
  if (!action) return null;

  // Create a clean copy without the documentSaveCtx.
  // documentSaveCtx contains non-serializable data that should not be put into state.
  const cleanAction = { ...action };
  
  // If meta.arg exists and contains documentSaveCtx, create a new arg object without it
  if (cleanAction.meta?.arg?.documentSaveCtx) {
    cleanAction.meta = {
      ...cleanAction.meta,
      arg: {
        ...cleanAction.meta.arg,
        documentSaveCtx: "[REMOVED_FROM_ERROR_STATE]"
      }
    };
  }
  
  return cleanAction;
}

export const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    clearErrorMessage(state) {
      state.errorMessage = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(showErrorToast, (state, action) => {
        state.errorMessage = sanitizeErrorAction(action);
      });
  },
});

export const {
  clearErrorMessage
} = errorSlice.actions

export const selectErrorMessage = (state) => state.error.errorMessage;

export default errorSlice.reducer;
